import { ActionExecutionStatus } from '@shared/generated/graphql';
import clsx from 'clsx';
import { PiCheckCircleBold, PiClockBold, PiXCircleBold } from 'react-icons/pi';
import { TbProgress } from 'react-icons/tb';

export function ActionExecutionStatusIcon(p: {
  status: ActionExecutionStatus;
  size?: number;
  shouldAnimate?: boolean;
}) {
  const DEFAULT_SIZE = 24;
  const size = p.size ?? DEFAULT_SIZE;
  switch (p.status) {
    case ActionExecutionStatus.COMPLETED:
      return (
        <PiCheckCircleBold
          size={size}
          className="text-green-500"
          title="Step Completed"
        />
      );
    case ActionExecutionStatus.FAILED:
      return (
        <PiXCircleBold
          size={size}
          className="text-red-500"
          title="Step Failed"
        />
      );
    case ActionExecutionStatus.WAITING:
      return (
        <PiClockBold
          size={size}
          className={clsx('text-gray-500', p.shouldAnimate && 'animate-ping')}
          title="Waiting for a response"
        />
      );
    case ActionExecutionStatus.IN_PROGRESS:
      return (
        <TbProgress
          size={size}
          className={clsx('text-indigo-500', p.shouldAnimate && 'animate-spin')}
          title="Waiting for a response"
        />
      );
    default:
      return null;
  }
}
